import React from 'react';
import { Icon } from './Icon.js';
export const IconCameraAuto = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M22 20L22 6L17 6L15 3L9 3L7 6L2 6L2 20L22 20Z", stroke: "currentColor", strokeWidth: "2", "data-color": "color-2", fill: "none" }),
        React.createElement("path", { d: "M9.5 14H14.5", stroke: "currentColor", strokeWidth: "2", fill: "none" }),
        React.createElement("path", { d: "M13.4248 8.61914L16.876 17H14.7129L12 10.4121L9.28711 17H7.12402L10.5752 8.61914L10.8301 8H13.1699L13.4248 8.61914Z", fill: "currentColor", "data-stroke": "none" })));
};
//# sourceMappingURL=IconCameraAuto.js.map